import { render, staticRenderFns } from "./ContainerOpcoes.vue?vue&type=template&id=63403cd8&scoped=true&"
import script from "./ContainerOpcoes.vue?vue&type=script&lang=js&"
export * from "./ContainerOpcoes.vue?vue&type=script&lang=js&"
import style0 from "./ContainerOpcoes.vue?vue&type=style&index=0&id=63403cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63403cd8",
  null
  
)

export default component.exports